import {getDirectorInfo} from '@/api/api';
import {Assessment} from '@/api/Coach/useGetCoachInfo';
import {Club} from '@/api/Director/club.interface';
import {Profile} from '@/user/player-info.interface';
import {Team} from '@/user/user.interface';
import {useQuery} from '@tanstack/react-query';

export type DirectorInfo = {
  directorDetails: Profile;
  teams: Team[];
  teamAssessments: {
    [key: string]: Assessment[];
  };
  club: Club | null;
};

export const useGetDirectorInfo = (directorId: string) => {
  return useQuery<DirectorInfo>({
    queryKey: ['director-info', directorId],
    queryFn: () => getDirectorInfo(directorId),
    enabled: !!directorId,
  });
};
